import AppConfig from '../appConfig';

/**
 * @typedef {import('../').VisualReportProfileType} VisualReportProfileType
 */

class UserPreferences {
    /** @type {VisualReportProfileType} */
    get analysisType() {
        return this._analysisType;
    }

    /** @param {VisualReportProfileType} analysisType */
    set analysisType(analysisType) {
        this._analysisType = analysisType;
    }

    /** @type {Object.<VisualReportProfileType, number[]>} */
    get analysisValues() {
        return this._analysisValues;
    }

    set analysisValues(analysisValues) {
        this._analysisValues = analysisValues;
    }

    get walkthroughs() {
        return this._walkthroughs;
    }

    set walkthroughs(value) {
        this._walkthroughs = value;
    }

    get mapDefaults() {
        return this._mapDefaults;
    }

    set mapDefaults(value) {
        this._mapDefaults = value;
    }

    get myDealsActiveList() {
        return this._myDealsActiveList;
    }

    set myDealsActiveList(value) {
        this._myDealsActiveList = value;
    }

    /** @type {number[]} */
    get selection() {
        if (
            this.analysisType &&
            this.analysisValues &&
            Object.prototype.hasOwnProperty.call(this.analysisValues, this.analysisType)
        ) {
            return this.analysisValues[this.analysisType];
        }
        return AppConfig.constants.defaultLocationAnalysisSelection;
    }

    getSelection(analysisType) {
        if (
            analysisType &&
            this.analysisValues &&
            Object.prototype.hasOwnProperty.call(this.analysisValues, analysisType)
        ) {
            return this.analysisValues[analysisType];
        }
        return [];
    }

    toJSON() {
        return {
            analysisType: this.analysisType,
            analysisValues: this.analysisValues,
            walkthroughs: this.walkthroughs,
            mapDefaults: this.mapDefaults,
        };
    }

    /**
     * Maps user preferences to location analysis format
     * @returns {{analysisTypeId: import('../').LocationAnalysisTypeId, selection: Set<number>}}
     */
    toLocationAnalysisFormat() {
        const analysisTypeId = this.analysisType
            ? this.analysisType === 'driving'
                ? 'DRIVING_TIME'
                : 'RADIUS'
            : AppConfig.constants.defaultLocationAnalysisSelectionType;

        const selection = new Set(this.selection);

        return {
            analysisTypeId,
            selection,
        };
    }

    /**
     * Static method to get location analysis format from potentially undefined user preferences
     * @param {UserPreferences|undefined} userPreferences
     * @returns {{analysisTypeId: import('../').LocationAnalysisTypeId, selection: Set<number>}}
     */
    static toLocationAnalysisFormat(userPreferences) {
        if (!userPreferences) {
            return {
                analysisTypeId: AppConfig.constants.defaultLocationAnalysisSelectionType,
                selection: new Set(AppConfig.constants.defaultLocationAnalysisSelection),
            };
        }

        return userPreferences.toLocationAnalysisFormat();
    }
}

export default UserPreferences;
